module.exports = __webpack_public_path__ + "static/media/calanderIcon.e35cad17.svg";